/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import HeadingServices from '../HeadingServices';
import HeadingTitle from '../HeadingTitle';
import Paragraf from '../Paragraf';

export default function Iso({ datasIso }) {
    return (
        <div>
            <HeadingServices title={datasIso.upperTitle} lowerTitle={datasIso.documentTitle} />
            <div className="container my-lg-3 my-2" >
                <div className="row align-items-center">
                    <div className="col">
                        <div className="float-right img-fluid pl-md-3 my-1 img-small-width">
                            <img
                                width="100%"
                                height="100%"
                                src="/images/consult/iso.png"
                                alt="iso-27001"
                            
                            />
                        </div>
                        <Paragraf parag={datasIso.paragrafOne} />
                        <Paragraf parag={datasIso.paragrafTwo} />
                        <Paragraf parag={datasIso.paragrafThree} />
                    </div>
                </div>
            </div>
        </div>
    )
}

